<ama-ng-app-store-hierarchy-list
  [items]="items"
  [actorTemplate]="actor"
  [selectedActor]="selectedActor"
  (expandEntity)="collapse($event)"
  (collapseEntity)="collapse($event)"
  (loadEntity)="selectEntity($event)">
  <ng-template #actor let-item let-depth="depth">
    @if (canDeployOrgOguLevels) {
      <input
        type="checkbox"
        class="form-check-input me-3 my-0 flex-shrink-0 ms-2"
        [id]="'hierarchy-item-deploy-' + item.actor.actorName"
        [checked]="(item | isEntityDeployed)"
        [indeterminate]="indeterminateDeploymentActors.has(item.actor.actorName)"
        (click)="deploy(item); $event.stopPropagation();"
        (dblclick)="$event.stopPropagation()"
               [disabled]="(item | isDeploymentDisabled) ||
               (deploymentService.isDeploymentAllowedForGivenEntity$(item) | async) === false"
        placement="top"
        container="body"
        aria-label="Deploy"/>
    }
    <button class="reset-button d-flex flex-row flex-grow-1 align-items-center overflow-hidden"
      [attr.aria-expanded]="!item.isCollapsed"
      (click)="selectEntity(item)"
      (dblclick)="collapse(item); $event.stopPropagation()"
      [id]="'hierarchy-item-' + item.actor.actorName">
      @if (depth < 2) {
        <span
          aria-hidden="true"
          class="{{ item.actor.actorType | entityIcon }} me-1">
        </span>
      }
      <label class="text-nowrap text-truncate me-1"
        [ngbTooltip]="item.actor.actorName | removeParentActor: item.parentOrg?.actorName"
                   [class.disabled]="(item | isDeploymentDisabled)
                   || (deploymentService.isDeploymentAllowedForGivenEntity$(item) | async) === false">
        {{ item.actor.actorName | removeParentActor: item.parentOrg?.actorName }}
      </label>
      @if ((item.tag | statusLabel) !== '') {
        <span
          aria-hidden="true"
                  [id]="'hierarchy-item-status-'
                                + item.actor.actorName"
          class="badge df-badge-dot {{ item.tag | statusStyle }} me-1 text-align-left ms-auto p-0">
          {{ item.tag | statusLabel }}
        </span>
      }
    </button>
    @if ((item | showExclusion: indeterminateExclusionActors.has(item.actor.actorName))) {
      <div
        class="ps-2 align-items-center d-flex justify-content-end"
        [class.ms-auto]="(item.tag | statusLabel) === ''">
        <input class="form-check-input mx-1" type="checkbox"
          [checked]="(item | isEntityExcluded)"
                   [disabled]="(item | isExclusionDisabled) ||
                   (deploymentService.isDeploymentAllowedForGivenEntity$(item) | async) === false"
                   [ngbTooltip]="deploymentService
                   .exclusionDisabledReason$(item, indeterminateExclusionActors.has(item.actor.actorName))| async"
          placement="top"
          container="body"
          (click)="exclude(item); $event.stopPropagation()"
          (dblclick)="$event.stopPropagation()"
                   [id]="'hierarchy-item-exclude-'
                                + item.actor.actorName"
          aria-label="Exclude"
          [indeterminate]="indeterminateExclusionActors.has(item.actor.actorName)"/>
          <span class="text-nowrap text-truncate ms-1 me-5" aria-hidden="true"
                  [class.disabled]="(item | isExclusionDisabled)
                  || (deploymentService.isDeploymentAllowedForGivenEntity$(item) | async) === false">
            Exclude
          </span>
        </div>
      } @else {
        <div class="align-tags" [class.ms-auto]="(item.tag | statusLabel) === ''"></div>
      }
    </ng-template>
  </ama-ng-app-store-hierarchy-list>
